// @ts-nocheck
import React, { useContext } from "react";
import UserContext from "../../../context/UserContext";
export default function PanelFormatterHOC({
  title,
  label,
  components,
}: {
  title: string[];
  label: string;
  components: React.Component[];
}) {
  const { superAdminOrders, customerOrders } = useContext(UserContext);
  return (
    <div
      // style={{ paddingTop: "8rem" }}
      className={`admin-formatter ${
        superAdminOrders ? "col-10 col-sm-7 col-md-9 mx-auto" : "col-lg-12"
      }`}
    >
      {!customerOrders && !superAdminOrders && (
        <ul className="header nav nav-tabs mb-3" id="tabs-tab" role="tablist">
          {title.map((value, index) => (
            <li className="nav-item mx-4" role="presentation">
              <button
                className={`title nav-link${index == 0 ? " active" : ""}`}
                id={`nav-${label}${index}-tab`}
                data-bs-toggle="tab"
                data-bs-target={`#tabs-${label}${index}`}
                type="button"
                role="tab"
                aria-controls={`tabs-${label}${index}`}
                aria-selected="true"
                key={`admin-panel-tab-buttons-${label}${index}`}
              >
                {value}
              </button>
            </li>
          ))}
        </ul>
      )}
      {/* <ul className="header nav nav-tabs mb-3" id="tabs-tab" role="tablist">
        {title.map((value, index) => (
          <li className="nav-item mx-4" role="presentation">
            <button
              className={`title nav-link${index == 0 ? " active" : ""}`}
              id={`nav-${label}${index}-tab`}
              data-bs-toggle="tab"
              data-bs-target={`#tabs-${label}${index}`}
              type="button"
              role="tab"
              aria-controls={`tabs-${label}${index}`}
              aria-selected="true"
              key={`admin-panel-tab-buttons-${label}${index}`}
            >
              {value}
            </button>
          </li>
        ))}
      </ul> */}
      <div className="body tab-content">
        {components.map((value, index) => (
          <div
            class={`tab-pane fade${index == 0 ? " show active" : ""}`}
            id={`tabs-${label}${index}`}
            role="tabpanel"
            aria-labelledby={`nav-${label}${index}-tab`}
            key={`admin-panel-tabs-${label}${index}`}
          >
            {value}
          </div>
        ))}
      </div>
    </div>
  );
}
